exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide-wrapper[data-v-1b69fbba]{text-align:center;font-size:1.5em}.hide-text[data-v-1b69fbba]{cursor:pointer}.hide-wrapper>hr[data-v-1b69fbba]{margin:0;border-color:gray}#emailOptinInput+label[data-v-1b69fbba],#overEighteenInput+label[data-v-1b69fbba]{display:inline;margin-left:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b69fbba","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Register.vue
// module id = 215
// module chunks = 0